export default __webpack_public_path__ + "resources/icons/n242-4772.png";